const ListModel = Backbone.Model.extend({

  // Resets services cache.
  clearServiceCache() {
    const { username } = loginContext.getCurrentDetails();
    const keyAllGroups = `${username}_services_social_and_all_groups`;
    const keyGroups = `${username}_services_social_and_groups`;
    const cache = new Cache();

    cache.remove(keyAllGroups);
    cache.remove(keyGroups);
  },
  sync(method, model, options) {
    const params = _.omit($.extend(true, {}, options), ['validate', 'parse', 'success', 'reset', 'remove', 'error', 'local', 'updateType']);
    // params.application_id = window.sendible_application_id;

    // Model to be created locally or server side
    options.local = (options.local != undefined) ? options.local : false;

    // if model doesn't have a collection then create a blank function
    if (model.hasOwnProperty('collection') === false) model.collection = { updateCache() {} };
    // update the cache if method isn't read
    if (method !== 'read') {
      model.collection.updateCache();
      this.clearServiceCache();
    }

    if (method === 'read') {
      Sendible.Connect.getList(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (result) => {
        options.error(result);
      });
    }

    if (method === 'create' && options.local === false) {
      const consumers = model.get('consumers') || [];
      const contributors = model.get('contributors') || [];

      params.list_name = model.get('list_name');
      params.list_type = model.get('list_type');
      params.color = model.get('color');
      params.consumers = consumers.join(',');
      params.contributors = contributors.join(',');

      Sendible.Connect.createList(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }

    if (method === 'update' && options.local === false) {
      // https://code.google.com/p/sendible-api/wiki/UpdateList

      /* Check the "type" of update, then set params accordingly.
              * Currently two uses for this models update: add service/edit list details
              * Add service has both "user_id" & "id"
              */

      if (options.hasOwnProperty('updateType') && options.updateType === 'moveListItem') {
        // Connect to Sendible API method and move list item
        Sendible.Connect.moveListItem(window.appConfig.applicationId, params, (data) => {
          options.success(data);
        }, (message) => {
          model.trigger('error', message);
        });

        return;
      }

      if (options.hasOwnProperty('updateType') && options.updateType === 'addServiceToList') {
        params.list_id = model.get('id');

        Sendible.Connect.addServiceToList(window.appConfig.applicationId, params, (data) => {
          options.success(data);
          model.collection.updateCache();
        }, (data) => {
          options.error(data);
        });
      } else {
        const consumers = model.get('consumers') || [];
        const contributors = model.get('contributors') || [];

        params.list_id = model.get('list_id');
        params.list_name = model.get('list_name');
        params.consumers = consumers.join(',');
        params.contributors = contributors.join(',');

        if (model.get('color')) params.color = model.get('color');

        Sendible.Connect.updateList(window.appConfig.applicationId, params, (data) => {
          options.success(data);
        }, (data) => {
          options.error(data);
        });
      }
    }

    if (method === 'delete') {
      // https://code.google.com/p/sendible-api/wiki/DeleteList
      params.list_id = model.get('list_id') || model.get('id');

      Sendible.Connect.deleteList(window.appConfig.applicationId, params, (data) => {
        options.success(data);
      }, (data) => {
        options.error(data);
      });
    }
  },

});

export default ListModel;
